import React from "react";
import { Link } from "react-router-dom";
import { SITE } from "@/lib/site";
import { Mail, Phone, MessageCircle } from "lucide-react";

const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-black border-t border-white/10 mt-24">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-12 md:py-16 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <img
            src={SITE.logoUrl}
            alt="Rincón Web"
            className="h-24 w-auto object-contain"
            loading="lazy"
          />
          <p className="mt-4 text-zinc-400 text-sm leading-relaxed max-w-xs">
            {SITE.tagline}. Creamos sitios que generan confianza y atraen
            clientes para tu negocio.
          </p>
        </div>

        <div>
          <div className="text-xs tracking-[0.25em] uppercase text-[#D4AF37] mb-4">
            Navegación
          </div>
          <ul className="space-y-2 text-zinc-300 text-sm">
            <li><Link data-testid="footer-link-home" to="/" className="hover:text-[#D4AF37]">Inicio</Link></li>
            <li><Link data-testid="footer-link-examples" to="/ejemplos" className="hover:text-[#D4AF37]">Ejemplos</Link></li>
            <li><Link data-testid="footer-link-packages" to="/paquetes" className="hover:text-[#D4AF37]">Paquetes</Link></li>
            <li><Link data-testid="footer-link-contact" to="/contacto" className="hover:text-[#D4AF37]">Contáctanos</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-xs tracking-[0.25em] uppercase text-[#D4AF37] mb-4">
            Contacto
          </div>
          <ul className="space-y-3 text-zinc-300 text-sm">
            <li className="flex items-center gap-2">
              <Phone className="w-4 h-4 text-[#D4AF37]" />
              <span>{SITE.whatsappDisplay}</span>
            </li>
            <li className="flex items-center gap-2">
              <MessageCircle className="w-4 h-4 text-[#D4AF37]" />
              <a
                data-testid="footer-wa"
                href={`https://wa.me/${SITE.whatsappNumber}`}
                target="_blank" rel="noopener noreferrer"
                className="hover:text-[#D4AF37]"
              >
                WhatsApp
              </a>
            </li>
            <li className="flex items-center gap-2">
              <Mail className="w-4 h-4 text-[#D4AF37]" />
              <a href="/contacto" className="hover:text-[#D4AF37]">Envíanos un mensaje</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/5 py-6 text-center text-zinc-500 text-xs">
        © {new Date().getFullYear()} Rincon Web. Todos los derechos reservados.
      </div>
    </footer>
  );
};

export default Footer;
